module.exports = __webpack_public_path__ + "static/img/home_process_buy_2.c87cfe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/official/home_process_buy_2.png
// module id = oSKV
// module chunks = 0